import { LanguageSelector } from '@/components/LanguageSelector';
import TelusPoweredLogo from '@assets/images/Telus-powered-by-humanoo-logo.png';
import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Public layout route — no sidebar, no authentication requirement.
 * Used for: /login, /auth/verify, and any future public pages.
 */
export const Route = createFileRoute('/_public')({ component: PublicLayout });

function PublicLayout() {
  return (
    // TODO: The gradient is not using the design colors, as these don't use the semantic approach, we might need to adjust these at some point. --- IGNORE ---
    <div className="login-aurora relative min-h-screen flex flex-col items-center justify-evenly bg-linear-to-br from-primary/30 via-background to-primary/5">
      <div className="absolute top-4 right-4">
        <LanguageSelector />
      </div>
      <img
        src={TelusPoweredLogo}
        alt="Telus Powered by Humanoo Logo"
        className="w-full max-w-xs h-auto"
      />
      <Outlet />
    </div>
  );
}
